// import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

// export const contactFromHomeAPI = createAsyncThunk(
//     "contactFromHomeAPI",
//     async (formData, { rejectWithValue }) => {
//         try {
//             const response = await fetch("https://remote-pad.bitsclan.com/api/contact-us-two", {
//                 method: "POST",
//                 headers: {
//                     "Content-Type": "application/json",
//                 },
//                 body: JSON.stringify(formData),
//             });

//             if (!response.ok) {
//                 const errorData = await response.json();
//                 return rejectWithValue(errorData);
//             }

//             const result = await response.json();
//             return result;
//         } catch (error) {
//             if (error.response && error.response.data) {
//                 return rejectWithValue(error.response.data);
//             }
//             return rejectWithValue({ message: "Something went wrong" });
//         }
//     }
// );

// export const contactFromContactUsAPI = createAsyncThunk(
//     "contactFromContactUsAPI",
//     async (formData, { rejectWithValue }) => {
//         try {
//             const response = await fetch("https://remote-pad.bitsclan.com/api/contact-us", {
//                 method: "POST",
//                 headers: {
//                     "Content-Type": "application/json",
//                 },
//                 body: JSON.stringify(formData),
//             });

//             if (!response.ok) {
//                 const errorData = await response.json();
//                 return rejectWithValue(errorData);
//             }

//             const result = await response.json();
//             return result;
//         } catch (error) {
//             if (error.response && error.response.data) {
//                 return rejectWithValue(error.response.data);
//             }
//             return rejectWithValue({ message: "Something went wrong" });
//         }
//     }
// );

// const initialState = {
//     data: null,
//     loading: false,
//     error: null,
// };

// const contactFormApiSlice = createSlice({
//     initialState,
//     name: "contactFormApiSlice",
//     reducers: {},
//     extraReducers: (builder) => {
//         builder
//             .addCase(contactFromHomeAPI.pending, (state) => {
//                 state.loading = true;
//                 state.error = null;
//             })
//             .addCase(contactFromHomeAPI.fulfilled, (state, action) => {
//                 state.loading = false;
//                 state.data = action.payload;
//             })
//             .addCase(contactFromHomeAPI.rejected, (state, action) => {
//                 state.loading = false;
//                 state.error = action.payload || "Something went wrong";
//             });
//     },

//     extraReducers: (builder) => {
//         builder
//             .addCase(contactFromContactUsAPI.pending, (state) => {
//                 state.loading = true;
//                 state.error = null;
//             })
//             .addCase(contactFromContactUsAPI.fulfilled, (state, action) => {
//                 state.loading = false;
//                 state.data = action.payload;
//             })
//             .addCase(contactFromContactUsAPI.rejected, (state, action) => {
//                 state.loading = false;
//                 state.error = action.payload || "Something went wrong";
//             });
//     },
// })

// export const { } = contactFormApiSlice.actions;
// export default contactFormApiSlice.reducer;

import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

// Async thunk for Home contact form
export const contactFromHomeAPI = createAsyncThunk(
  "contactFromHomeAPI",
  async (formData, { rejectWithValue }) => {
    try {
      const response = await fetch(
        "https://remote-pad.bitsclan.com/api/contact-us-two",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(formData),
        }
      );

      if (!response.ok) {
        const errorData = await response.json();
        return rejectWithValue(errorData);
      }

      return await response.json();
    } catch (error) {
      return rejectWithValue({ message: "Something went wrong" });
    }
  }
);

// Async thunk for Contact Us page form
export const contactFromContactUsAPI = createAsyncThunk(
  "contactFromContactUsAPI",
  async (formData, { rejectWithValue }) => {
    try {
      const response = await fetch(
        "https://remote-pad.bitsclan.com/api/contact-us",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(formData),
        }
      );

      if (!response.ok) {
        const errorData = await response.json();
        return rejectWithValue(errorData);
      }

      return await response.json();
    } catch (error) {
      return rejectWithValue({ message: "Something went wrong" });
    }
  }
);

// Initial state
const initialState = {
  data: null,
  loading: false,
  error: null,
};

// Redux slice
const contactFormApiSlice = createSlice({
  name: "contactFormApiSlice",
  initialState,
  reducers: {}, // keep empty for now
  extraReducers: (builder) => {
    // Handle contactFromHomeAPI
    builder
      .addCase(contactFromHomeAPI.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(contactFromHomeAPI.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(contactFromHomeAPI.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Something went wrong";
      });

    // Handle contactFromContactUsAPI
    builder
      .addCase(contactFromContactUsAPI.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(contactFromContactUsAPI.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(contactFromContactUsAPI.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Something went wrong";
      });
  },
});

export default contactFormApiSlice.reducer;